import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import useResize from "../../../hooks/resize";
import AlmubCard from "../AlbumCard/AlbumCard";

export default function SwiperList({ slides, slideEl }) {
  const device = useResize("");
  const devices = {
    desktop: 3,
    laptop: 2,
    tablet: 2,
    mobile: 1,
    smallMobile: 1,
  };
  return (
    <Swiper
      spaceBetween={30}
      slidesPerView={devices[device]}
      onSlideChange={() => console.log("slide change")}
      onSwiper={(swiper) => console.log(swiper)}>
      {!!slides
        ? slides.map((slide) => {
            return (
              <SwiperSlide>
                {React.cloneElement(slideEl, {
                  title: slide.name,
                })}
              </SwiperSlide>
            );
          })
        : undefined}
    </Swiper>
  );
}
